<template>
  <b-modal id="add-role" centered hide-footer hide-header @hidden="reset">
    <h3>Add Role</h3>
    <b-form @submit.prevent="createRole">
      <b-form-group label="Name" label-for="role-name">
        <b-form-input id="role-name" v-model="name" required />
      </b-form-group>
      <b-form-group label="Description" label-for="role-description">
        <b-form-input id="role-description" v-model="description" required />
      </b-form-group>
      <div class="mt-3 text-right">
        <b-btn
          class="ml-2 px-4"
          variant="secondary"
          @click="$bvModal.hide('add-role')"
        >
          Cancel
        </b-btn>
        <b-btn
          class="ml-2 px-4"
          variant="primary"
          type="submit"
          :disabled="!name || !description"
        >
          Create
        </b-btn>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import API from "@/api";

export default {
  props: {
    orgId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    name: "",
    description: ""
  }),

  methods: {
    async createRole() {
      const { success } = await API.createOrgRole(
        this.orgId,
        this.name,
        this.description
      );
      if (!success) return;

      this.$emit("updated");
      this.$bvModal.hide("add-role");
      this.$notify({
        type: "success",
        text: `Role "${this.name}" created`
      });
    },

    reset() {
      this.name = "";
      this.description = "";
    }
  }
};
</script>
